import React from 'react';

export interface OrganizationLayoutNavigationProps {
    children: React.ReactElement | Array<React.ReactElement | null> | null;
}

export const OrganizationLayoutNavigation: React.FC<OrganizationLayoutNavigationProps> = (
    props
) => <>{props.children}</>;
